import React from 'react';
import {stylesheet} from 'typestyle';
import {px} from 'csx';
import {I18n} from '../../../i18n/i18n';
import {LightGreyColor, WhiteColor} from '../../../styles/colors';

export const PreviewPageBreakBlock: React.FunctionComponent<{}> = () => {
    return (
        <div className={breakCss.breakContainer}>
            <span className={breakCss.breakText}>
                <I18n i18nKey="report:reportBuildingBlockType.pageBreak" />
            </span>
        </div>
    );
};
const breakCss = stylesheet({
    breakContainer: {
        marginLeft: -15,
        marginRight: -15,
        height: 20,
        borderBottom: '3px dashed ' + LightGreyColor,
        color: LightGreyColor,
        textAlign: 'center',
    },
    breakText: {
        fontSize: 15,
        lineHeight: px(37),
        backgroundColor: WhiteColor,
        padding: '0px 10px',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheetBlocks/PreviewPageBreakBlock.tsx